import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import {digs} from "diggerize"
import {HelperText} from "react-native-paper"
import InputContainer from "./input-container"
import memo from "set-state-compare/src/memo"
import React from "react"
import useInput from "@kaspernj/api-maker/build/use-input"
import {View} from "react-native"

const styles = {
  currentOptionPresentationText: {
    color: "#2c2c96",
    fontSize: 16,
    fontWeight: 600
  },
  nothingSelected: {
    color: "#6783b8",
    fontSize: 16
  },
  selectContainer: {
    backgroundColor: "#f0f4fc",
    border: "1px solid #f0f4fc",
    borderRadius: 8,
    paddingTop: 14,
    paddingRight: 24,
    paddingBottom: 14,
    paddingLeft: 24
  }
}

const ComponentsChalkyLayoutSelectContainer = memo(shapeComponent(class ComponentsChalkyLayoutSelectContainer extends ShapeComponent {
  setup() {
    const {wrapperOpts} = useInput({props: this.props})
    const {errors} = digs(wrapperOpts, "errors")

    this.setInstance({errors, wrapperOpts})
  }

  render() {
    const {errors, wrapperOpts} = this.tt
    const {children, containerProps} = this.props

    return (
      <View {...containerProps}>
        <InputContainer label={wrapperOpts.label} {...this.props.inputContainerProps}>
          {children}
        </InputContainer>
        {errors.length > 0 &&
          <HelperText type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </View>
    )
  }

  errorMessages() {
    const {errors} = this.tt
    const errorMessages = []

    for (const error of errors) {
      for (const errorMessage of error.getErrorMessages()) {
        errorMessages.push(errorMessage)
      }
    }

    return errorMessages
  }
}))

const withSelectContainer = (WrappedComponent) => memo((props) => {
  const {containerProps, ...restProps} = props

  return (
    <ComponentsChalkyLayoutSelectContainer {...props}>
      <WrappedComponent {...restProps} />
    </ComponentsChalkyLayoutSelectContainer>
  )
})

export {styles, withSelectContainer}
export default ComponentsChalkyLayoutSelectContainer
